// Import global styles
require("normalize.css");
require("@fontsource/montserrat/400.css");
require("@fontsource/montserrat/700.css");
require("instantsearch.css/themes/reset.css");
require("./src/styles/scss/main.scss");

exports.onRouteUpdate = () => {
  document.querySelectorAll('.gatsby-highlight').forEach((block) => {
    if (block.querySelector('.copy-btn')) return;

    const btn = document.createElement('button');
    btn.className = 'copy-btn';
    btn.textContent = 'Copy';

    btn.addEventListener('click', () => {
      const codeEl = block.querySelector('code') || block.querySelector('pre');
      const text = codeEl ? codeEl.innerText : '';
      navigator.clipboard.writeText(text).then(() => {
        btn.textContent = 'Copied!';
        setTimeout(() => {
          btn.textContent = 'Copy';
        }, 2000);
      });
    });

    block.appendChild(btn);
  });
};

// A stub function is needed because gatsby won't load this file otherwise
// (https://github.com/gatsbyjs/gatsby/issues/6759)
exports.onClientEntry = () => {
  if (process.env.GATSBY_SENTRY_DSN) {
    const Sentry = require('@sentry/browser');
    Sentry.init({
      dsn: process.env.GATSBY_SENTRY_DSN,
      environment: process.env.NODE_ENV,
      enabled: ['production', 'stage'].includes(process.env.NODE_ENV),
    });
  }
};
